import { FC, ReactNode } from 'react';
import { EmptyLayout } from '@srm/ui/shell/AppShell';
import { TITLE_PREFIX } from '@/configuration';

export interface ILayoutEmptyProps {
    /** Наполнение */
    children: ReactNode | ReactNode[];
}

const LayoutEmpty: FC<ILayoutEmptyProps> = ({ children }: ILayoutEmptyProps) => (
    <EmptyLayout title={`${TITLE_PREFIX} — Авторизация`}>{children}</EmptyLayout>
);

export default LayoutEmpty;
